import SelectInput from "../Components/SelectInput";
import React, { useEffect } from "react";
import {
  getDocDataSnap,
  setDocData,
} from "../../../utils/firebase/Firebase.utils";
import { useSelector } from "react-redux";
import { setDoc } from "firebase/firestore";
import toast from "react-hot-toast";
import CloseButton from "../../../components/CloseButton";
import HistoryModule from "../../../components/HistoryModule";
import TaskAssignmentModule from "../../../components/TaskAssignmentModule";
import DetailsPageHead from "../../../components/DetailsPageHead";
import DisplayAvatar from "../../../components/DisplayAvatar";
import CommentBlock from "../../../components/CommentBlock";
import {
  sendBulkNotifications,
  sendNotification,
} from "../../../utils/notifications";
import { addNewNotification } from "../../../utils/EleghoUtils";
import { FiEdit2, FiX, FiMessageSquare, FiSend } from "react-icons/fi";
import IOSSpinner from "../../../components/IOSSpinner";
import { unitNumberLabel } from "../../../utils/constants";

export default function GatePassDetailsPage({ data, setViewMode }) {
  const [newStatus, setNewStatus] = React.useState(data.status || "");
  const [formData, setFormData] = React.useState(data);
  const [updateHappened, setUpdateHappened] = React.useState(false);
  const [addMode, setAddMode] = React.useState(false);
  const [comments, setComments] = React.useState([]);
  const [newComment, setNewComment] = React.useState("");
  const [editMode, setEditMode] = React.useState(false);
  const [assignedToArray, setAssignedToArray] = React.useState(
    data.assignedTo || []
  );
  const [statusUpdateLoading, setStatusUpdateLoading] = React.useState(false);
  const [savingComment, setSavingComment] = React.useState(false);
  const [assignmentSaving, setAssignmentSaving] = React.useState(false);
  const [resolutionSaving, setResolutionSaving] = React.useState(false);

  const currentUser = useSelector((state) => state.userObject);

  useEffect(() => {
    const fetchData = async () => {
      await getDocDataSnap("gatePass", data.id, (data) => {
        setFormData(data);
        setComments(data.comments || []);
      });
    };
    fetchData();
  }, []);

  const status = ["pending", "approved", "rejected", "completed", "returned"];
  const statusOptions = status.map((item) => ({ value: item, label: item }));

  const handleSelect = (selected) => {
    setUpdateHappened(true);
    setFormData({ ...formData, status: selected.value });
  };

  const handleUpdateStatus = async () => {
    setStatusUpdateLoading(true);
    const updatedStatus = formData.status;
    setNewStatus(updatedStatus);
    const docObject = {
      status: updatedStatus,
      updatedBy: currentUser.uid,
      updatedName: currentUser.displayName,
      updatedEmail: currentUser.email,
      updateType: "Status is updated to " + updatedStatus,
      history: [
        ...(formData.history || []),
        {
          action: "Status is updated to",
          to: updatedStatus,
          at: new Date().toLocaleString(),
          by: currentUser.displayName,
        },
      ],
    };

    await setDocData("gatePass", data.id, docObject);

    const fcmNotification = {
      title: "Gate Pass Status Updated",
      body: `${currentUser.displayName} updated the status of your gate pass (${data.identifier}) to ${updatedStatus}`,
      data: {
        id: data.id,
      },
    };

    await sendNotification(data.user, fcmNotification);

    const notification = {
      to: data.user,
      user: data.requestedBy,
      from: currentUser.email,
      fromName: currentUser.displayName,
      subject: "Gate Pass Status Updated",
      message: `${currentUser.displayName} updated the status of your gate pass (${data.identifier}) to ${updatedStatus}`,
      dateTime: new Date(),
      read: false,
      type: "gatePass",
      id: data.id,
    };

    await addNewNotification(notification);

    toast.success("Status Updated Successfully");
    setUpdateHappened(false);
    setEditMode(false);
    setStatusUpdateLoading(false);
  };

  const handleAddMode = () => {
    setAddMode(!addMode);
  };

  const handleChange = (e) => {
    setNewComment(e.target.value);
  };

  const handleSubmit = async () => {
    setSavingComment(true);
    const docObject = {
      comments: [
        ...comments,
        {
          message: newComment,
          createdAt: new Date().toLocaleString(),
          createdBy: currentUser.displayName,
          email: currentUser.email,
        },
      ],
      history: [
        ...(formData.history || []),
        {
          action: "Comment added by",
          to: currentUser.displayName,
          at: new Date().toLocaleString(),
          by: currentUser.displayName,
        },
      ],
    };
    await setDocData("gatePass", data.id, docObject);

    const fcmNotification = {
      title: "New Comment on Gate Pass",
      body: `${currentUser.displayName} commented on your gate pass (${data.identifier})`,
      data: {
        id: data.id,
      },
    };

    await sendNotification(data.user, fcmNotification);

    const notification = {
      to: data.user,
      user: data.requestedBy,
      from: currentUser.email,
      fromName: currentUser.displayName,
      subject: "New Comment on Gate Pass",
      message: `${currentUser.displayName} commented on your gate pass (${data.identifier})`,
      dateTime: new Date(),
      read: false,
      type: "gatePass",
      id: data.id,
    };

    await addNewNotification(notification);

    toast.success("Comment Added Successfully");
    setNewComment("");
    setComments([
      ...comments,
      docObject.comments[docObject.comments.length - 1],
    ]);
    setSavingComment(false);
  };

  const handleCancelEdit = () => {
    setEditMode(false);
    setFormData(data);
    setAssignedToArray(data.assignedTo || []);
    toast.error("Edit Cancelled");
  };

  const handleAssignment = async () => {
    if (editMode) {
      setAssignmentSaving(true);
      const docObject = {
        ...formData,
        updatedAt: new Date().toLocaleString(),
        updatedBy: currentUser.uid,
        updatedName: currentUser.displayName,
        updatedEmail: currentUser.email,
        updateType: "Gate Pass is assigned",
        assignedTo: assignedToArray,
        history: [
          ...(formData?.history || []),
          {
            action:
              assignedToArray.length === 0
                ? "Unassigned"
                : "Gate Pass is Assigned to",
            at: new Date().toLocaleString(),
            by: currentUser.displayName,
            to: assignedToArray.map((item) => item.label).join(", "),
          },
        ],
      };

      const fcmNotification = {
        title: "Gate Pass Assigned",
        body: `${currentUser.displayName} has assigned your gate pass (${data.identifier})`,
        data: {
          id: data.id,
        },
      };

      await sendNotification(data.user, fcmNotification);

      const notification = {
        to: data.user,
        user: data.requestedBy,
        from: currentUser.email,
        fromName: currentUser.displayName,
        subject: "Gate Pass Assigned",
        message: `${currentUser.displayName} has assigned your gate pass (${data.identifier})`,
        dateTime: new Date(),
        read: false,
        type: "gatePass",
        id: data.id,
      };

      await addNewNotification(notification);

      setDocData("gatePass", data.id, docObject);
      toast.success("Gate Pass is Updated");
      setEditMode(false);
      setAssignmentSaving(false);
    }
  };

  const handleDeleteComment = async (index) => {
    if (window.confirm("Are you sure you want to delete this comment?")) {
      const newComments = comments.filter((item, i) => i !== index);
      await setDocData("gatePass", data.id, {
        comments: newComments,
        history: [
          ...(formData.history || []),
          {
            action: "Comment deleted by",
            to: currentUser.displayName,
            at: new Date().toLocaleString(),
            by: currentUser.displayName,
          },
        ],
      });
      toast.success("Comment Successfully Deleted");
      setComments(newComments);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "approved":
        return "bg-green-100 text-green-800 border-green-200";
      case "rejected":
        return "bg-red-100 text-red-800 border-red-200";
      case "pending":
        return "bg-amber-100 text-amber-800 border-amber-200";
      case "completed":
        return "bg-purple-100 text-purple-800 border-purple-200";
      case "returned":
        return "bg-gray-100 text-gray-800 border-gray-200";
      default:
        return "bg-gray-100 text-gray-800 border-gray-200";
    }
  };

  const allowedEditors = ["admin", "super-admin", "security"];
  const isEditable = allowedEditors.includes(currentUser.role);

  return (
    <div className="min-h-screen p-4 relative text-xs">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 mb-4 sm:mb-6">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4 sm:mb-6">
            <div className="text-base sm:text-lg font-semibold text-[#363062]">
              Gate Pass Details
            </div>
            <div className="flex items-center gap-2 sm:gap-4 mr-12">
              {allowedEditors.some((role) =>
                currentUser.roles.includes(role)
              ) && (
                <button
                  className={`px-3 sm:px-4 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2 ${
                    editMode
                      ? "bg-red-500 text-white hover:bg-red-600 shadow-sm"
                      : "bg-[#363062] text-white hover:bg-opacity-90 shadow-sm"
                  }`}
                  onClick={() => {
                    if (editMode) {
                      handleCancelEdit();
                    } else {
                      setEditMode(true);
                    }
                  }}
                >
                  {editMode ? (
                    <>
                      <FiX className="w-4 h-4" />
                      Cancel Edit
                    </>
                  ) : (
                    <>
                      <FiEdit2 className="w-4 h-4" />
                      Edit Gate Pass
                    </>
                  )}
                </button>
              )}

              {setViewMode !== undefined && (
                <button
                  className="p-2 rounded-lg hover:bg-gray-100 transition-colors absolute top-6 right-6"
                  onClick={() => setViewMode(false)}
                >
                  <FiX className="w-5 h-5 text-gray-600" />
                </button>
              )}
            </div>
          </div>

          {/* Status Badge */}
          <div className="flex flex-col sm:flex-row sm:items-center gap-4 mb-4 sm:mb-6">
            <div
              className={`px-3 py-1.5 rounded-full border ${getStatusColor(
                formData.status
              )} font-medium capitalize text-xs sm:text-sm`}
            >
              {formData.status}
            </div>
            {editMode && (
              <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                <SelectInput
                  name={"status"}
                  placeholder={"Select Status"}
                  options={statusOptions}
                  onChange={(selected) => handleSelect(selected)}
                  value={statusOptions.find(
                    (item) => item.value === formData.status
                  )}
                  className="w-full sm:w-48"
                />
                <button
                  className="px-4 py-2 bg-[#363062] text-white rounded-lg hover:bg-opacity-90 disabled:opacity-50 disabled:cursor-not-allowed font-medium shadow-sm flex items-center gap-2 text-sm"
                  disabled={!updateHappened || statusUpdateLoading}
                  onClick={handleUpdateStatus}
                >
                  {statusUpdateLoading ? (
                    <>
                      <IOSSpinner className="w-4 h-4" />
                      <span>Updating...</span>
                    </>
                  ) : (
                    "Update Status"
                  )}
                </button>
              </div>
            )}
          </div>

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6">
            {/* Left Column - Gate Pass Details */}
            <div className="lg:col-span-2 space-y-4 sm:space-y-6">
              {/* Gate Pass Information Card */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
                <div className="border-b border-gray-100 p-4">
                  <h3 className="font-semibold text-sm sm:text-base text-[#363062]">
                    Gate Pass Information
                  </h3>
                </div>
                <div className="p-4 sm:p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6">
                    <div>
                      <div className="text-xs sm:text-sm text-gray-500 mb-1">
                       {unitNumberLabel}
                      </div>
                      <div className="font-medium text-xs sm:text-sm">
                        {data.identifier}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs sm:text-sm text-gray-500 mb-1">
                        Provider
                      </div>
                      <div className="font-medium text-xs sm:text-sm capitalize">
                        {data.deliveryCompany}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs sm:text-sm text-gray-500 mb-1">
                        Date of Delivery
                      </div>
                      <div className="font-medium text-xs sm:text-sm">
                        {data.deliveryDate}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs sm:text-sm text-gray-500 mb-1">
                        Requestor Email
                      </div>
                      <div className="font-medium text-xs sm:text-sm">
                        {data.requestedBy || data.user}
                      </div>
                    </div>
                  </div>

                  {/* Items */}
                  <div className="mt-4">
                    <div className="text-xs sm:text-sm text-gray-500 mb-2">
                      Items
                    </div>
                    <div className="bg-gray-50 rounded-lg p-3 sm:p-4 border border-gray-100 text-xs sm:text-sm">
                      {data.items || "No items listed"}
                    </div>
                  </div>

                  {/* Request Date & Time */}
                  <div className="mt-4">
                    <div className="text-xs sm:text-sm text-gray-500 mb-1">
                      Request Date & Time
                    </div>
                    <div className="font-medium text-xs sm:text-sm">
                      {data.requestDateTime?.seconds
                        ? `${new Date(
                            data.requestDateTime.seconds * 1000
                          ).toLocaleDateString()} ${new Date(
                            data.requestDateTime.seconds * 1000
                          ).toLocaleTimeString()}`
                        : "Not specified"}
                    </div>
                  </div>
                </div>
              </div>

              {/* Comments Section */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
                <div className="border-b border-gray-100 p-4">
                  <h3 className="font-semibold text-sm sm:text-base text-[#363062] flex items-center gap-2">
                    <FiMessageSquare className="w-4 h-4" />
                    Comments
                  </h3>
                </div>
                <div className="p-4 sm:p-6">
                  <div className="mb-4 sm:mb-6">
                    <textarea
                      name="newComment"
                      className="w-full rounded-lg p-3 sm:p-4 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#363062] focus:border-transparent resize-none text-xs sm:text-sm"
                      rows="3"
                      onChange={handleChange}
                      placeholder="Write your comment here..."
                      value={newComment}
                    ></textarea>
                    <div className="flex justify-end mt-3">
                      <button
                        className="px-3 sm:px-4 py-2 bg-[#8FCD00] text-white rounded-lg hover:bg-opacity-90 disabled:opacity-50 disabled:cursor-not-allowed font-medium shadow-sm flex items-center gap-2 text-xs sm:text-sm"
                        onClick={handleSubmit}
                        disabled={!newComment.trim() || savingComment}
                      >
                        {savingComment ? (
                          <>
                            <IOSSpinner className="w-4 h-4" />
                            <span>Saving...</span>
                          </>
                        ) : (
                          <>
                            <FiSend className="w-4 h-4" />
                            Submit Comment
                          </>
                        )}
                      </button>
                    </div>
                  </div>

                  <div className="space-y-4">
                    {comments.length > 0 ? (
                      comments.map((comment, index) => (
                        <CommentBlock
                          key={index}
                          comment={comment}
                          currentUser={currentUser}
                          handleDeleteComment={() => handleDeleteComment(index)}
                        />
                      ))
                    ) : (
                      <div className="text-gray-500 italic p-4 bg-gray-50 rounded-lg text-center text-xs sm:text-sm">
                        No comments yet
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Assignment & History */}
            <div className="space-y-4 sm:space-y-6">
              {/* Assignment Card */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-100 ">
                <div className="border-b border-gray-100 p-4">
                  <h3 className="font-semibold text-sm sm:text-base text-[#363062]">
                    Task Assignment
                  </h3>
                </div>
                <div className="p-4 sm:p-6">
                  <TaskAssignmentModule
                    assignedToArray={assignedToArray}
                    setAssignedToArray={setAssignedToArray}
                    editMode={editMode}
                  />
                  {editMode && (
                    <div className="mt-4 sm:mt-6 flex flex-col sm:flex-row sm:items-center gap-4 justify-end">
                      <button
                        className="px-3 sm:px-4 py-2 bg-[#363062] text-white rounded-lg hover:bg-opacity-90 font-medium shadow-sm flex items-center gap-2 text-xs sm:text-sm disabled:opacity-70"
                        onClick={handleAssignment}
                        disabled={assignmentSaving}
                      >
                        {assignmentSaving ? (
                          <>
                            <IOSSpinner className="w-4 h-4" />
                            <span>Saving...</span>
                          </>
                        ) : (
                          "Save Assignment"
                        )}
                      </button>
                      <button
                        className="px-3 sm:px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 font-medium text-xs sm:text-sm"
                        onClick={handleCancelEdit}
                        disabled={assignmentSaving}
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* History Card */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
                <div className="border-b border-gray-100 p-4">
                  <h3 className="font-semibold text-sm sm:text-base text-[#363062]">
                    History
                  </h3>
                </div>
                <div className="p-4 sm:p-6">
                  <HistoryModule data={formData.history || []} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
